import { requiredStrategy } from '../core';
import { creditCardCvcFormateStrategy } from './credit-card-cvc-formate-strategy';

export const creditCardCvcStrategy = (value: string) => {
  return creditCardCvcFormateStrategy(value) && requiredStrategy(value);
};
